import { render } from "./BuildingQueue.vue?vue&type=template&id=642c043d"
import script from "./BuildingQueue.vue?vue&type=script&lang=js"
export * from "./BuildingQueue.vue?vue&type=script&lang=js"

import "./BuildingQueue.vue?vue&type=style&index=0&id=642c043d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/BuildingQueue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "642c043d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('642c043d', __exports__)) {
    api.reload('642c043d', __exports__)
  }
  
  module.hot.accept("./BuildingQueue.vue?vue&type=template&id=642c043d", () => {
    api.rerender('642c043d', render)
  })

}


export default __exports__